import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { OutputEmitterRef } from '@angular/core';

export const onDrop = (
  { previousIndex, currentIndex }: CdkDragDrop<Array<{ [key: string]: any }>>,
  recordList: any[],
  reportReordered: OutputEmitterRef<any>
) => {
  recordList = recordList.slice();
  const positions = recordList.map(({ position }) => position);
  const indexes = [previousIndex, currentIndex].sort((a, b) => a - b);
  recordList = recordList.slice();
  moveItemInArray(recordList, previousIndex, currentIndex);
  recordList = recordList.map((record, index) => ({ ...record, position: positions[index] }));
  recordList.slice(indexes[0], indexes[1] + 1).map(({ recordId, position }) => ({ recordId, position }));
  reportReordered.emit(recordList);
};
